/**
  订单路由配置
*/
import React from 'react';
import InboundOrder from '@/pages/InboundOrder';
import InboundOrderDetail from '@/pages/InboundOrderDetail';
import OutboundOrder from '@/pages/OutboundOrder';
import OutboundOrderDetail from '@/pages/OutboundOrderDetail';
import BounceOrder from '@/pages/BounceOrder/index';
import BounceOrderDetail from '@/pages/BounceOrderDetail';
import UpdateExpress from '@/pages/UpdateExpress';
import FbaOrderList from '@/pages/FbaOrderList';
import FbaOrderDetail from '@/pages/FbaOrderDetail';
import VASOrder from '@/pages/VASOrder';
import VASOrderDetail from '@/pages/VASOrder/VasOrderDetail';
// import VASOrderDetail from '@/pages/VASOrderDetail';
import UpdateOrderWeight from '@/pages/UpdateOrderWeight';

export default [
  {
    path: '/order/inboundorder',
    // component: InboundOrder,
    component: React.lazy(() => import(/* webpackChunkName: 'InboundOrder' */ '@/pages/InboundOrder')),
  },
  {
    path: '/order/inboundorderdetail/:tid',
    // component: InboundOrderDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'InboundOrderDetail' */ '@/pages/InboundOrderDetail')),
  },
  {
    path: '/order/outboundorder',
    // component: OutboundOrder,
    component: React.lazy(() => import(/* webpackChunkName: 'OutboundOrder' */ '@/pages/OutboundOrder')),
  },
  {
    path: '/order/outboundorderdetail/:tid',
    // component: OutboundOrderDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'OutboundOrderDetail' */ '@/pages/OutboundOrderDetail')),
  },
  {
    path: '/order/bounceorder',
    // component: BounceOrder,
    component: React.lazy(() => import(/* webpackChunkName: 'BounceOrder' */ '@/pages/BounceOrder')),
  },
  {
    path: '/order/bounceorderdetail/:tid',
    // component: BounceOrderDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'BounceOrderDetail' */ '@/pages/BounceOrderDetail')),
  },
  {
    path: '/order/updateexpress',
    // component: UpdateExpress,
    component: React.lazy(() => import(/* webpackChunkName: 'UpdateExpress' */ '@/pages/UpdateExpress')),
  },
  {
    path: '/order/fbaorder',
    // component: FbaOrderList,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaOrderList' */ '@/pages/FbaOrderList')),
  },
  {
    path: '/order/fbaorderdetail/:tid',
    // component: FbaOrderDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'FbaOrderDetail' */ '@/pages/FbaOrderDetail')),
  },
  {
    path: '/order/vasorder',
    component: VASOrder,
    // component: React.lazy(() => import(/* webpackChunkName: 'VASOrder' */ '@/pages/VASOrder')),
  },
  {
    path: '/order/vasorderdetail/:tid',
    component: VASOrderDetail,
    // component: React.lazy(() => import(/* webpackChunkName: 'VASOrderDetail' */ '@/pages/VASOrderDetail')),
  },
  {
    path: '/order/updateorderweight',
    // component: UpdateOrderWeight,
    component: React.lazy(() => import(/* webpackChunkName: 'UpdateOrderWeight' */ '@/pages/UpdateOrderWeight')),
  },
  {
    path: '/order/packingrepertoire',
    // component: UpdateOrderWeight,
    component: React.lazy(() => import(/* webpackChunkName: 'UpdateOrderWeight' */ '@/pages/PackingRepertoire')),
  },
  {
    path: '/order/packingrepertoiredetail/:tid',
    component: React.lazy(() => import(/* webpackChunkName: 'UpdateOrderWeight' */ '@/pages/packingRepertoireDetails')),
  },
  {
    path: '/order/dwsMeasure',
    component: React.lazy(() => import(/* webpackChunkName: 'UpdateOrderWeight' */ '@/pages/OrderMeasure')),
  },
  {
    path: '/order/updateSn',
    // component: UpdateSn,
    component: React.lazy(() => import(/* webpackChunkName: 'UpdateSn' */ '@/pages/UpdateSn')),
  },
  {
    path: '/order/updatewarehouseremark',
    component: React.lazy(
      () => import(/* webpackChunkName: 'updatewarehouseremark' */ '@/pages/UpdatewarehouseRemark'),
    ),
  },
];
